const WEBSITE_NAME = "Welcome to Our Website";
const WEBSITE_DESCRIPTION = "Discover amazing content and connect with us.";
const BUTTON = "Get Started";
const TITLE = "Card";
const CARD_DESCRIPTION = "Explore this amazing feature that helps you."


export {WEBSITE_NAME, WEBSITE_DESCRIPTION, BUTTON, TITLE, CARD_DESCRIPTION };